import * as Dashboard from 'devexpress-dashboard';
import * as Model from 'devexpress-dashboard/model';
import * as Designer from 'devexpress-dashboard/designer';

const svgIcon = '<svg version="1.1" id="iconDescription" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"><style type="text/css">.dx-dashboard-icon {fill:currentColor;}</style><path class="dx-dashboard-icon" d="M12,3c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S17,3,12,3z M12,19c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S15.9,19,12,19z M12,17L12,17c-0.6,0-1-0.4-1-1v-5c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.4,1,1v5C13,16.6,12.6,17,12,17zM12,9L12,9c-0.6,0-1-0.4-1-1l0,0c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.4,1,1l0,0C13,8.6,12.6,9,12,9z"/></svg>';
Dashboard.ResourceManager.registerIcon(svgIcon);

// 1. Model
const textProperty: Model.CustomPropertyMetadata = {
	ownerType: Model.DashboardItem,
	propertyName: 'Identifier',
	defaultValue: '',
	valueType: 'string',
};
Model.registerCustomProperty(textProperty);

// 3. Designer
function onCustomizeSections(args) {
	const dashboardItem = args.dashboardItem;
	const currentValue = dashboardItem.customProperties.getValue(textProperty.propertyName);

	if (!currentValue) {
		dashboardItem.customProperties.setValue(
			textProperty.propertyName,
			generateUUID(),
		);
	}

	args.addSection({
		title: 'Identifier',
		onFieldDataChanged: function (e) {
			// e.component.beginUpdate();
			// e.component.endUpdate();
		},
		items: [
			{
				dataField: textProperty.propertyName,
				editorType: 'dxTextBox',
				label: {
					text: 'Identifier',
				},
			},
		],
	});
}

// 4. Event Subscription
export class ItemIdentifierExtension {
	name = 'ItemIdentifierExtension';
	constructor(private readonly dashboardControl: Dashboard.DashboardControl) {
	}

	start() {
		const optionsPanelExtension = <Designer.OptionsPanelExtension> this.dashboardControl.findExtension('item-options-panel');

		if (optionsPanelExtension) {
			optionsPanelExtension.on(
				'customizeSections',
				onCustomizeSections,
			);
		}
	}

	stop() {
		const optionsPanelExtension = <Designer.OptionsPanelExtension> this.dashboardControl.findExtension('item-options-panel');

		if (optionsPanelExtension) {
			optionsPanelExtension.off(
				'customizeSections',
				onCustomizeSections,
			);
		}
	}
}

// Function to generate UUID
function generateUUID(): string {
	return 'xxxx-xxxx'.replace(
		/[x]/g,
		() => ((Math.random() * 16) | 0).toString(16),
	);
}